import { useEffect, useState } from "react";
import { Building2, MapPin, Receipt, UserRound, Clock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { PlanPicker } from "@/components/forms/PlanPicker";

const Info = ({ icon: Icon, title, children, testId }) => (
  <div className="rounded-2xl border border-[#E2E5DC] bg-white p-5" data-testid={testId}>
    <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] text-[#0F2D5E]"><Icon className="h-4 w-4" /> {title}</p>
    <div className="mt-3 space-y-1 text-sm text-[#12201A]">{children}</div>
  </div>
);

export default function CompanyArea() {
  const { user, setUser } = useAuth();
  const [plans, setPlans] = useState([]);
  const c = user.company;

  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)); }, []);

  const choose = async (plan_id) => {
    try {
      await api.put("/company/plan", { plan_id });
      setUser({ ...user, company: { ...c, plan_id } });
      toast.success("Piano aggiornato");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:py-12" data-testid="company-area-page">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0F2D5E]">Area azienda</p>
      <h1 className="mt-2 break-words text-4xl font-extrabold tracking-tight sm:text-5xl" data-testid="company-area-name">{c.name}</h1>
      <p className="mt-4 flex items-start gap-2 rounded-2xl bg-[#F4C20D]/15 px-4 py-3 text-sm text-[#5C4700]" data-testid="company-payment-status">
        <Clock className="mt-0.5 h-4 w-4 shrink-0" /> Pagamento da attivare: a breve potrai pagare il piano con PayPal e addebito automatico. Le segnalazioni per le aziende arriveranno con la prossima fase.
      </p>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Info icon={Building2} title="Azienda" testId="company-info-azienda"><p className="font-semibold">{c.name}</p><p>P. IVA {c.piva}</p></Info>
        <Info icon={MapPin} title="Sede" testId="company-info-sede"><p>{c.sede.indirizzo}</p><p>{c.sede.cap} {c.sede.comune} ({c.sede.provincia})</p><p>{c.sede.regione}</p></Info>
        <Info icon={UserRound} title="Referente" testId="company-info-referente"><p className="font-semibold">{user.name}</p><p className="break-all">{user.email}</p><p>{user.phone}</p></Info>
        <Info icon={Receipt} title="Fatturazione" testId="company-info-fatturazione">{c.sdi && <p>SDI {c.sdi}</p>}{c.pec && <p className="break-all">PEC {c.pec}</p>}</Info>
      </div>
      <h2 className="mt-12 text-2xl font-bold">Il tuo piano</h2>
      <p className="mt-1 text-sm text-[#495850]">Puoi cambiarlo in qualsiasi momento finché il pagamento non è attivo.</p>
      <div className="mt-6"><PlanPicker plans={plans} value={c.plan_id} onChange={choose} /></div>
    </main>
  );
}
